import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  TextInput,
  useRecordContext,
  EditButton,
  useTranslate,
} from 'react-admin';
import { Avatar, Box, Typography } from '@mui/material';
import type { Contact } from '../../types/chat.types';
import { useContactAvatarUrl } from '../../hooks/useContactAvatarUrl';
import { useAppLocale } from '../../hooks/useAppLocale';

const ContactFilters = () => {
  const translate = useTranslate();
  return [
    <TextInput
      source="name_q"
      label={translate('resources.contact.filters.searchName')}
      alwaysOn
      key="name"
    />,
    <TextInput
      source="email_q"
      label={translate('resources.contact.filters.searchEmail')}
      key="email"
    />,
  ];
};

const ContactAvatar = () => {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  const resolvedAvatarUrl = useContactAvatarUrl(record?.avatarFileId);
  const avatarUrl = record?.profilePicUrl || resolvedAvatarUrl;
  if (!record) return null;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Avatar src={avatarUrl ?? undefined} sx={{ width: 32, height: 32 }}>
        {record.name?.[0]?.toUpperCase() || record.email?.[0]?.toUpperCase() || '?'}
      </Avatar>
      <Box>
        <Typography variant="body2">{record.name || translate('resources.contact.unknown')}</Typography>
      </Box>
    </Box>
  );
};

export const ContactList = () => {
  const translate = useTranslate();
  const locale = useAppLocale();

  return (
    <List
      filters={ContactFilters()}
      sort={{ field: 'lastActivityAt', order: 'DESC' }}
      perPage={25}
    >
      <Datagrid
        bulkActionButtons={false}
        rowClick="show"
      >
        <ContactAvatar />
        <EmailField source="email" emptyText="-" />
        <TextField source="phoneNumber" emptyText="-" />
        <DateField
          source="lastActivityAt"
          label={translate('resources.contact.lastActivity')}
          showTime
          locales={locale}
          options={{
            dateStyle: 'short',
            timeStyle: 'short',
          }}
          emptyText="-"
        />
        <DateField
          source="createdAt"
          locales={locale}
          options={{ dateStyle: 'short' }}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};
